@if (invoice(); as invoice) {
  <!-- Desktop -->
<div class="hidden md:flex w-full h-full">
  <aside class="shrink-0 w-[320px] h-full bg-[#0f3d3b] flex flex-col overflow-hidden pt-8 pb-7 px-7 gap-4">
    <div class="flex justify-center w-full" [@checkPop]>
      <div class="size-[72px] rounded-full bg-[#218c59]/[0.18] flex items-center justify-center">
        <div class="size-14 rounded-full bg-[#218c59] shadow-[0_6px_14px_0_rgba(33,140,89,0.4)] flex items-center justify-center text-white text-[28px] font-bold leading-none">
          <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[32px] max-h-[28px] text-white mt-[6px]"></mat-icon>
        </div>
      </div>
    </div>
    <h2 class="text-white !text-[24px] !font-bold !leading-[1.1] !m-0 text-center">Payment received</h2>
    <p class="text-[#a1c4c7] text-[13px] leading-[1.5] !m-0 text-center">Welcome to {{ invoice.userPlan?.name }} ·
      @switch (invoice.userPlan?.billingCycle) {
        @case ('MONTHLY') {
          Monthly subscription
        }
        @case ('YEARLY') {
          Annual subscription
        }
      }
      . Your account is now active.</p>
    <div class="bg-white/[0.06] border border-white/[0.12] rounded-[10px] px-[14px] py-3 flex flex-col gap-[6px] w-full">
      <span class="self-start inline-flex items-center gap-[6px] bg-[#66e5b2] text-[#022d35] text-[9px] font-bold tracking-[0.36px] py-[3px] pl-2 pr-[10px] rounded-[100px]">
        <span class="size-[6px] rounded-full bg-[#022d35]"></span>
        <span>{{ invoice.userPlan?.userPlanType }} · ACTIVE</span>
      </span>
      <p class="text-white text-[14px] font-semibold !m-0">
        @switch (invoice.userPlan?.billingCycle) {
          @case ('MONTHLY') {
            Monthly subscription
          }
          @case ('YEARLY') {
            Annual subscription
          }
        }
      </p>
      <p class="text-[#a1c4c7] text-[11px] !m-0">Active until {{ invoice.userPlan?.expirationDate | date:'d MMM yyyy' }}</p>
    </div>
    <div class="flex items-end justify-between w-full mt-auto">
      <span class="text-[#a1c4c7] text-[12px]">Total paid</span>
      <span class="text-[#66e5b2] text-[18px] font-bold">{{ invoice.amount | number : '1.2-2' }} USDT</span>
    </div>
  </aside>
  <section class="flex-1 h-full bg-white flex flex-col min-w-0 px-7 py-6 gap-[14px] relative">
    <button type="button"
            class="absolute top-[7px] right-[7px] size-7 rounded-full bg-[#f5f7f7] border-none cursor-pointer flex items-center justify-center text-[#6b7d82] text-[11px] font-semibold transition-colors hover:bg-[#e8ebeb] hover:text-[#022d35]"
            (click)="matDialogRef.close()">
      <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-[#022D35]"></mat-icon>
    </button>
    <header class="flex items-center justify-between">
      <div class="flex flex-col gap-[2px]">
        <p class="text-[#022d35] text-[16px] font-semibold !m-0">What's unlocked</p>
        <p class="text-[#6b7d82] text-[11px] !m-0">Invoice {{ invoice.uuid }}</p>
      </div>
    </header>
    <div class="h-px w-full bg-[#edf0f0]"></div>
    <ul class="list-none !m-0 p-0 flex flex-col gap-[10px]">
      <li class="flex items-start gap-[10px]">
        <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white font-bold flex items-center justify-center">
          <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
        </span>
        <div class="flex-1 flex flex-col gap-[1px] min-w-0">
          <p class="text-[#022d35] text-[13px] font-semibold !m-0">{{invoice.amount | number : '1.0-0'}} balance ready</p>
          <p class="text-[#6b7d82] text-[11px] !m-0">Across all 4 AML providers</p>
        </div>
      </li>
      <li class="flex items-start gap-[10px]">
        <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white font-bold flex items-center justify-center">
          <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
        </span>
        <div class="flex-1 flex flex-col gap-[1px] min-w-0">
          <p class="text-[#022d35] text-[13px] font-semibold !m-0">Per-report rates locked</p>
          <p class="text-[#6b7d82] text-[11px] !m-0">
            {{priceRange()}} USDT for
            @switch (invoice.userPlan?.billingCycle) {
              @case ('MONTHLY') {
                1 month
              }
              @case ('YEARLY') {
                12 months
              }
            }
          </p>
        </div>
      </li>
      @if (invoice.userPlan?.billingCycle === 'YEARLY') {
        <li class="flex items-start gap-[10px]">
          <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white font-bold flex items-center justify-center">
            <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
          </span>
          <div class="flex-1 flex flex-col gap-[1px] min-w-0">
            <p class="text-[#022d35] text-[13px] font-semibold !m-0">{{ invoice.userPlan?.complianceHoursGranted }}h compliance support</p>
            <p class="text-[#6b7d82] text-[11px] !m-0">Available across the year</p>
          </div>
        </li>
      }
      <li class="flex items-start gap-[10px]">
        <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white font-bold flex items-center justify-center">
          <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
        </span>
        <div class="flex-1 flex flex-col gap-[1px] min-w-0">
          <p class="text-[#022d35] text-[13px] font-semibold !m-0">Dedicated account manager</p>
          <p class="text-[#6b7d82] text-[11px] !m-0">Priority hack/theft support</p>
        </div>
      </li>
    </ul>
    <div class="flex-1 min-h-0"></div>
    <div class="flex gap-2 w-full">
      <!-- <button
        (click)="onDownloadInvoice()"
        type="button"
        class="flex-1 flex items-center justify-center gap-[6px] py-3 px-[14px] rounded-[10px] text-[13px] font-semibold cursor-pointer border border-[#dee3e3] bg-white text-[#022d35] transition-all hover:bg-[#f5f7f7] hover:border-[#022d35] active:scale-[0.98]"
      >
        Go to invoices →
      </button> -->
      <button
        (click)="onGoDashboard()"
        type="button"
        class="group flex-1 flex items-center justify-center gap-[6px] py-3 px-[14px] rounded-[10px] text-[13px] font-semibold cursor-pointer border-none bg-[#022d35] text-white transition-all hover:bg-[#1a8c99] hover:shadow-[0_6px_16px_0_rgba(23,115,125,0.45)] active:scale-[0.98]"
      >
        Go to dashboard
        <span class="transition-transform group-hover:translate-x-[3px]">→</span>
      </button>
    </div>
  </section>
</div>

<!-- Mobile -->
<div class="relative h-full overflow-y-auto flex md:hidden flex-col items-center gap-4 w-full pt-8 pb-6 px-6 bg-[#0f3d3b]">
  <button type="button"
          class="absolute top-[14px] right-[14px] size-8 rounded-full bg-white/[0.16] border-none cursor-pointer flex items-center justify-center transition-colors hover:bg-white/[0.26]"
          (click)="matDialogRef.close()">
    <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-white"></mat-icon>
  </button>
  <div class="flex items-center justify-center" [@checkPop]>
    <div class="flex items-center justify-center size-24 rounded-full bg-[#218c59]/[0.18]">
      <div class="flex items-center justify-center size-[68px] rounded-full bg-[#218c59] shadow-[0_6px_14px_0_rgba(33,140,89,0.4)]">
        <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[32px] max-h-[28px] text-white mt-[6px]"></mat-icon>
      </div>
    </div>
  </div>

  <div class="flex flex-col items-center gap-[6px] w-full text-center">
    <h2 class="!m-0 text-[24px] font-bold text-white leading-tight text-center">Payment received</h2>
    <p class="!m-0 text-[13px] font-normal text-[#a1c4c7] leading-[1.5] text-center">
      Welcome to {{ invoice.userPlan?.name }} ·
      @switch (invoice.userPlan?.billingCycle) {
        @case ('MONTHLY') {
          Monthly
        }
        @case ('YEARLY') {
          Annual
        }
      }<br>
      Your account is now active.
    </p>
  </div>

  <div class="flex flex-col gap-2 w-full px-4 py-[14px] rounded-[12px] bg-white/[0.06] border border-white/[0.12]">
    <div class="flex items-center justify-between w-full">
      <span class="text-[11px] font-normal text-[#a1c4c7]">Plan</span>
      <span class="text-[12px] font-semibold text-white">{{ invoice.userPlan?.name }} ·
        @switch (invoice.userPlan?.billingCycle) {
          @case ('MONTHLY') {
            Monthly
          }
          @case ('YEARLY') {
            Annual
          }
        }</span>
    </div>
    <div class="flex items-center justify-between w-full">
      <span class="text-[11px] font-normal text-[#a1c4c7]">Active until</span>
      <span class="text-[12px] font-semibold text-white">{{ invoice.userPlan?.expirationDate | date:'d MMM yyyy' }}</span>
    </div>
    <div class="flex items-center justify-between w-full">
      <span class="text-[11px] font-normal text-[#a1c4c7]">Invoice ID</span>
      <span class="text-[12px] font-medium text-white text-right flex items-center gap-2" [appCopyToClipboardCopied]="invoice.uuid">
        <span>{{ invoice.uuid | cropWithDotsCenter }}</span>
        <mat-icon [class]="'text-white !w-[12px] !h-[12px] !text-[12px]'" svgIcon="copy-icon"></mat-icon>
      </span>
    </div>
    <div class="h-px w-full bg-white/[0.12]"></div>
    <div class="flex items-center justify-between w-full">
      <span class="text-[13px] font-semibold text-white">Total paid</span>
      <span class="text-[16px] font-semibold text-[#66e5b2]">
        {{ invoice.amount | number : '1.2-2' }} <span class="text-[#66e5b2] text-[14px] font-semibold">USDT</span>
      </span>
    </div>
  </div>

  <p class="!m-0 self-start text-[9px] font-bold text-[#66e5b2] tracking-[0.54px]">WHAT'S UNLOCKED</p>

  <ul class="list-none !m-0 p-0 flex flex-col gap-2 w-full">
    <li class="flex items-center gap-2">
      <span class="flex items-center justify-center size-[18px] rounded-full bg-[#218c59]">
        <span class="text-[10px] font-bold text-white leading-none">✓</span>
      </span>
      <span class="text-[12px] font-normal text-white">{{invoice.amount}} balance ready</span>
    </li>
    <li class="flex items-center gap-2">
      <span class="flex items-center justify-center size-[18px] rounded-full bg-[#218c59]">
        <span class="text-[10px] font-bold text-white leading-none">✓</span>
      </span>
      <span class="text-[12px] font-normal text-white">Per-report rates locked</span>
    </li>
    @if (invoice.userPlan?.billingCycle === 'YEARLY') {
      <li class="flex items-center gap-2">
        <span class="flex items-center justify-center size-[18px] rounded-full bg-[#218c59]">
          <span class="text-[10px] font-bold text-white leading-none">✓</span>
        </span>
        <span class="text-[12px] font-normal text-white">{{ invoice.userPlan?.complianceHoursGranted }}h compliance support</span>
      </li>
    }
    <li class="flex items-center gap-2">
      <span class="flex items-center justify-center size-[18px] rounded-full bg-[#218c59]">
        <span class="text-[10px] font-bold text-white leading-none">✓</span>
      </span>
      <span class="text-[12px] font-normal text-white">Dedicated account manager</span>
    </li>
  </ul>

  <div class="flex flex-col gap-2 w-full">
    <button type="button"
            class="flex items-center justify-center w-full py-[14px] rounded-[12px] bg-[#022d35] text-white text-[14px] font-semibold transition-colors hover:bg-[#1a8c99] active:scale-[0.98]"
            (click)="onGoDashboard()">
      Go to dashboard →
    </button>
    <!-- <button type="button"
            class="flex items-center justify-center w-full py-[14px] rounded-[12px] bg-white border border-[#dee3e3] text-[#022d35] text-[14px] font-semibold transition-colors hover:bg-[#f5f7f7]"
            (click)="onDownloadInvoice()">
      Go to invoices →
    </button> -->
  </div>
</div>

}
